module.exports = __webpack_public_path__ + "img/wt-spines-res.2756165b.jpg";